/**
 * A badge for indicating if a user has received notifications.
 *
 * It should display a blue circle with an Aria Label.
 */
import {t} from "@lingui/core/macro";
import {StyleSheet, type CSSProperties} from "aphrodite";
import * as React from "react";

import {View} from "@khanacademy/wonder-blocks-core";
import {color, spacing} from "@khanacademy/wonder-blocks-tokens";

type Props = {
    size: "large" | "medium";
    style?: CSSProperties;
};

const NotificationsBadge = ({size, style}: Props): React.ReactElement => (
    <View
        aria-label={t`You have a new notification`}
        style={[
            styles.root,
            size === "large" && styles.large,
            size === "medium" && styles.medium,
            style,
        ]}
    />
);

const styles = StyleSheet.create({
    root: {
        display: "inline-flex",
        backgroundColor: color.blue,
        borderRadius: "50%",
    },

    large: {
        height: spacing.large_24,
        width: spacing.large_24,
    },

    medium: {
        height: spacing.medium_16,
        width: spacing.medium_16,
    },
});

export default NotificationsBadge;
